// extracted by mini-css-extract-plugin
export var leftAlign = "_2d-2";
export var popper = "_2d-0";
export var subtitle = "_2d-1";